import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import './RowDisplay.scss';
var labelClass = function labelClass(labelPosition) {
  return classNames({
    'text-right': labelPosition === 'right',
    'text-left': labelPosition === 'left'
  });
};
var mainClass = function mainClass(noHover) {
  return classNames({
    'common-display-profile': true,
    'editable-panel': true,
    'common-display-profile--no-hover': noHover
  });
};
var lastUpdateVersionsText = function lastUpdateVersionsText(lastUpdate, itemId) {
  if (lastUpdate !== null && lastUpdate !== void 0 && lastUpdate.versions) {
    var _context;
    var version = _findInstanceProperty(_context = lastUpdate.versions).call(_context, function (obj) {
      return obj.item_id === itemId;
    });
    if (version !== null && version !== void 0 && version.created_at) {
      if (version !== null && version !== void 0 && version.first_name && version !== null && version !== void 0 && version.last_name) {
        var name = /*#__PURE__*/React.createElement("strong", null, version.first_name, " ", version.last_name);
        return /*#__PURE__*/React.createElement("span", {
          className: "text-xs text-gray-600"
        }, "Last update by ", name, " on ", moment(version.created_at).format('MMMM D, YYYY'));
      } else {
        return "Last update on ".concat(moment(version.created_at).format('MMMM D, YYYY'));
      }
    }
  }
  return 'This field has not been updated in the last 180 days.';
};
var lastUpdateText = function lastUpdateText(lastUpdate) {
  var recently_updated_by_name = lastUpdate.recently_updated_by_name,
    recently_updated_at = lastUpdate.recently_updated_at;
  if (recently_updated_at && recently_updated_by_name) {
    var name = /*#__PURE__*/React.createElement("strong", null, recently_updated_by_name);
    return /*#__PURE__*/React.createElement("span", {
      className: "text-xs text-gray-600"
    }, "Last update by ", name, " on ", moment(recently_updated_at).utc().format("MMMM D, YYYY"));
  }
  if (recently_updated_at && !recently_updated_by_name) {
    return "Last update on ".concat(moment(recently_updated_at).utc().format('MMMM D, YYYY'));
  }
  return 'This field has not been updated in the last 180 days.';
};
var lastUpdateViaIngestionText = function lastUpdateViaIngestionText(lastUpdate) {
  return "Last updated via roster ingestion on ".concat(moment(lastUpdate.recently_updated_at).format('MMMM D, YYYY[ at ]h[:]mm a'));
};
var RowDisplay = function RowDisplay(_ref) {
  var children = _ref.children,
    deleteSection = _ref.deleteSection,
    editSection = _ref.editSection,
    hideDelete = _ref.hideDelete,
    hideEdit = _ref.hideEdit,
    label = _ref.label,
    labelPosition = _ref.labelPosition,
    noHover = _ref.noHover,
    lastUpdate = _ref.lastUpdate,
    showLastUpdate = _ref.showLastUpdate,
    itemId = _ref.itemId,
    isInsuranceIngested = _ref.isInsuranceIngested;
  return /*#__PURE__*/React.createElement("div", {
    className: mainClass(noHover)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-3"
  }, /*#__PURE__*/React.createElement("h5", {
    className: labelClass(labelPosition)
  }, label)), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-9 flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, children)), !hideDelete && deleteSection && /*#__PURE__*/React.createElement("div", {
    className: "flex-none"
  }, deleteSection), editSection && /*#__PURE__*/React.createElement("div", {
    className: "flex-none w-12"
  }, !hideEdit && editSection)), /*#__PURE__*/React.createElement("div", {
    className: "w-1/4 pr-4 inline-block"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-2/4 inline-block"
  }, isInsuranceIngested ? /*#__PURE__*/React.createElement("p", {
    className: "last_updated text-xs italic text-gray-600 mt-2"
  }, lastUpdateViaIngestionText(lastUpdate)) : showLastUpdate && /*#__PURE__*/React.createElement("p", {
    className: "last_updated text-xs italic text-gray-600 mt-2"
  }, itemId === null ? lastUpdateText(lastUpdate) : lastUpdateVersionsText(lastUpdate, itemId)))));
};
RowDisplay.propTypes = {
  children: PropTypes.node.isRequired,
  deleteSection: PropTypes.node,
  editSection: PropTypes.node,
  hideDelete: PropTypes.bool,
  hideEdit: PropTypes.bool,
  label: PropTypes.node,
  labelPosition: PropTypes.string,
  noHover: PropTypes.bool,
  lastUpdate: PropTypes.object,
  showLastUpdate: PropTypes.bool,
  itemId: PropTypes.string,
  isInsuranceIngested: PropTypes.bool
};
RowDisplay.defaultProps = {
  hideEdit: false,
  hideDelete: false,
  label: '',
  labelPosition: 'right',
  noHover: false,
  lastUpdate: {
    recently_updated_by_name: null,
    recently_updated_at: null,
    versions: null
  },
  showLastUpdate: false,
  itemId: null,
  isInsuranceIngested: false
};
export default RowDisplay;
//# sourceMappingURL=index.js.map